
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pride",
      function () {
        return require("private-next-pages/pride.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pride"])
      });
    }
  